import { Button, Icon } from '@advanza/ui'
import { useNavigate } from 'react-router-dom'

interface ServiceProviderButtonProps {
    serviceProviderId: number | null
}

const ServiceProviderButton = ({ serviceProviderId }: ServiceProviderButtonProps) => {
    const navigate = useNavigate()

    if (!serviceProviderId) {
        return null
    }

    const handleClick = () => {
        navigate(`/service/providers/provider/${serviceProviderId}`)
    }

    return (
        <Button
            name="text"
            appearance="outlined_primary"
            onClick={handleClick}
            style={{ marginRight: '0px', height: '36px', padding: '10px 8px' }}>
            <Icon name="people" style={{ marginRight: '4px', color: '#ff6b35' }} />
            View Service Provider
        </Button>
    )
}

export default ServiceProviderButton
